//Import
import React from 'react'
import styled from 'styled-components'
import styles from './FormInputInteres_styles'

// Componente base
const FormInput_base = ({
                            type = 'text',
                            formlabel,
                            handleInputBlur,
                            handleInputChange,
                            name,
                            value,      // <--- Recibe el valor del estado global
                            readOnly,   // <--- Recibe si debe estar bloqueado o no
                            ...props
                        }) => {
    return (
        <div {...props}>
            <label htmlFor={formlabel}>{formlabel}</label>
            <input
                type={type}
                name={name}
                className={`FormInput transparent-input ${readOnly ? 'input-disabled' : ''}`}
                onBlur={handleInputBlur}
                onChange={handleInputChange}
                required
                readOnly={readOnly} // <--- Ahora es dinámico
                value={value}       // <--- Ahora usa el valor del formValues
            />
        </div>
    )
}
const FormInputInteres = styled(FormInput_base)`
  ${styles}
`
export default FormInputInteres
